module.exports = __webpack_public_path__ + "img/edit.6d5ea925.svg";